import React from 'react';
import BlogsPageHeader from './BlogsPageHeader';
import BlogsPageSession from './BlogsPageSession';

function BlogsPage() {
  return (
    <div className="page-wrapper">
      <BlogsPageHeader />
      <BlogsPageSession />
    </div>
  );
}

export default BlogsPage;
